<template>
  <div style="width: 100%; height: 100%;">
    <div style="width: 100%; height: 70px;">
      {{item.metaType}}
    </div>
    <div style="width: 100%; height: calc(100% - 140px);">
      <div class="container text-left">
        <div class="row">
          <div class="col-12">
            Title
            <input class="form-control" v-model="item.title"/>
          </div>

        </div>
        <div class="row">
          <div class="col-12">
            <div class="item-main-image-container" v-if="item.mainImage !== null && item.mainImage.length > 0" v-bind:style="{backgroundImage : 'url(' + item.mainImage + ')'}">

            </div>
            <progress value="0" max="100" id="uploader-add"></progress>
            <input accept="image/*" type="file" ref="file" value="upload" @change="photoPicked" data-buttonText="Select Photo">

            or Image URL
            <input type="text" class="form-control" v-model="item.mainImage"/>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            Short Description
            <textarea class="form-control" v-model="item.shortDescription" rows="3"/>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            Content
            <textarea class="form-control" v-model="item.description" rows="10"/>
          </div>
        </div>
      </div>
    </div>
    <div style="width: 100%; height: 70px;">
      <div class="container">
        <div class="row">
          <div class="col-4">
            <button class="btn btn-dark form-control" @click="closeView">Close</button>
          </div>
          <div class="col-4">
            <button class="btn btn-danger form-control" @click="deleteItem">Delete</button>
          </div>
          <div class="col-4">
            <button class="btn btn-primary form-control" @click="updateItem">Update</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {deleteComMeta, updateComMeta} from "../../api/ecomApi";
import {showDialog} from "../../api/utils";

import firebase from "firebase/app";
import EventBus from "../../api/event-bus";
export default {
  name: "EcomMetaItemView",
  props: {
    item:{
      type:Object,
      default: function(){return null;}
    },
    onUpdated: {
      type: Function,
      default: null,
    },
    onClose: {
      type: Function,
      default: null,
    },
    onDeleted: {
      type: Function,
      default: null,
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    closeView: function() {
      if(this.onClose !== null) {
        this.onClose();
      }
    },
    updateItem: function() {
      // if(this.item.title === null || this.item.title.length === 0) {
      //
      //   return;
      // }
      let self = this;
      updateComMeta(this.item)
        .then(function(data) {
          if(data.success === true) {
            if(self.onUpdated !== null) {
              self.onUpdated(data.item);
            }
            if(self.onClose !== null) {
              self.onClose();
            }
          } else {
            showDialog(data.message);
          }
        })
    },
    deleteItem: function() {
      let self = this;
      deleteComMeta(this.item.id)
        .then(function(data) {
          if(data.success === true) {
            if(self.onDeleted !== null) {
              self.onDeleted(data.item);
            }
            if(self.onClose !== null) {
              self.onClose();
            }
          } else {
            showDialog(data.message);
          }
        })
    },
    photoPicked: function(e) {
      const uploader = document.getElementById('uploader-add');
      let getFile = e.target.files[0];
      console.log("File name - " + getFile.name);
      //set storage ref
      let d = new Date();
      let name  = d.getTime();
      let names = getFile.name.split('.');

      let path = 'shop/' + this.item.metaType +'/'+ this.item.id + '/' +  name + '.' + names[names.length-1];
      let storageRef = firebase.storage().ref();
      let mountainsRef = storageRef.child(path);
      let self = this;
      EventBus.$emit("showLoading", true);
      mountainsRef.put(getFile).on('state_changed',
        function progress(snapshot){

          let percentage = (snapshot.bytesTransferred / snapshot.totalBytes) *100;
          console.log("percentage " + percentage);
          uploader.value = percentage;
        },
        function error(err){
          // EventBus.$emit("showLoading", false);
          EventBus.$emit("showLoading", false);
          console.log(err);
        },
        function complete(){
          EventBus.$emit("showLoading", false);
          console.log('complete upload');
          // self.$data.editGoodItem.imageUrl = 'https://storage.googleapis.com/uko-projects.appspot.com/' + path;
          // self.updateEditGoodItem();

          setTimeout(function() {
            self.onPhotoUploaded('https://storage.googleapis.com/kokoro-294123.appspot.com/' + path);
          }, 2000);
        }
      );
    },
    onPhotoUploaded: function(url) {
      this.item.mainImage = url;
    }
  }
}
</script>

<style scoped>
.item-main-image-container {
  width: 300px;
  height: 300px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

}
</style>



// WEBPACK FOOTER //
// src/components/ItemView/EcomMetaItemView.vue